import { render } from "./ExclusionAreaEditForm.vue?vue&type=template&id=3af13ef7&scoped=true"
import script from "./ExclusionAreaEditForm.vue?vue&type=script&lang=js"
export * from "./ExclusionAreaEditForm.vue?vue&type=script&lang=js"

import "./ExclusionAreaEditForm.vue?vue&type=style&index=0&id=3af13ef7&scoped=true&lang=css"

import exportComponent from "/home/runner/work/GPSviaAIS/GPSviaAIS/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af13ef7"]])

export default __exports__